import React from 'react'
import PreferMobile from './PreferMobile'
import HowItWorks from './HowItWorks'
import RestaurantShowcase from './RestaurantShowcase'

class OverSixDays extends React.Component {
  render() {
    const {
      isAuthenticated,
      loadingDeliveringRestaurants,
      restaurantLogos,
      showJoin
    } = this.props
    return (
      <div className="row center-xs">
        <div className="col-xs-12">
          <h2 className="coming-soon-title">Coming Soon!</h2>
          {isAuthenticated ? (
            <PreferMobile />
          ) : (
            <div style={{ paddingTop: '12px' }}>
              <button
                onClick={() => {
                  showJoin()
                }}
                className="primary"
                id="create-account-btn"
              >
                Create Account
              </button>
            </div>
          )}
          <hr className="coming-soon-hr" />
          <HowItWorks />
          <hr className="coming-soon-hr" />
          {loadingDeliveringRestaurants ? (
            <i className="spinner spinner-lg primary" />
          ) : (
            <RestaurantShowcase restaurantLogos={restaurantLogos} />
          )}
        </div>
      </div>
    )
  }
}

export default OverSixDays
